import { createPlaceholderKeys } from "@/common/helpers/list-keys";
import { useSidebarNavigation } from "@/common/hooks/use-navigation";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  useSidebar,
} from "@/components/ui/sidebar";
import { getAppEnvironmentBranding } from "@/config/app-environment";
import { LayoutGroup } from "framer-motion";
import { useMemo } from "react";
import { Link } from "wouter";
import { AlphartisLogo } from "../icons";
import { SidebarItemRenderer } from "./_components/sidebar-item-renderer";

export function AppSidebar() {
  const { setOpenMobile } = useSidebar();

  const { items: orderedNavigation, isLoading: isNavigationLoading } = useSidebarNavigation();

  const navigationOrderKey = useMemo(() => orderedNavigation.map((item) => item.id).join("|"), [orderedNavigation]);

  const environmentBranding = getAppEnvironmentBranding();

  return (
    <Sidebar className="border-r-0!">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Link to="~/home" onClick={() => setOpenMobile(false)}>
                <div className="inline-flex" style={{ color: environmentBranding.color }}>
                  <AlphartisLogo width={20} />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">{environmentBranding.label}</span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {isNavigationLoading ? (
              createPlaceholderKeys(5, "menu-item").map((key) => (
                <SidebarMenuItem key={key}>
                  <SidebarMenuSkeleton showIcon className="my-0.5 h-9 gap-3 px-3" />
                </SidebarMenuItem>
              ))
            ) : (
              <LayoutGroup>
                {orderedNavigation.map((item) => (
                  <SidebarItemRenderer key={item.id} item={item} animateLayout layoutDependency={navigationOrderKey} />
                ))}
              </LayoutGroup>
            )}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
